import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  Provider,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Popover } from 'primeng/popover';
import { MixOptions } from './mix-on-the-fly.const';

export const MIX_ON_THE_FLY_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MixOnTheFlyComponent),
  multi: true
};


/*Popover.prototype.align = function () {
  alignOld.call(this);
};*/

@Component({
    selector: 'pump-mix-on-the-fly',
    template: `
    <div class="mix-on-the-fly-container">
    <p-Popover data-mix #op dismissable="true">
        <ng-template pTemplate>
          <div class="mix-on-the-fly-popup-content">
            <ul class="mix-on-the-fly-list" role="listbox">
            @for (option of options; track option) {
              <li class="mix-on-the-fly-item" (click)="selectItem($event, option)">
                <div class="item-row">
                    <svg-icon class="mix-icon" [icon]="option.icon"></svg-icon>
                    <div class="item-text">{{option.label}}</div>
                </div>
              </li>
            }
            </ul>
          </div>
        </ng-template>
    </p-Popover>
      <div>
        <a role="button" class="svg-icon-button" [ngClass]="{'svg-icon-button-disabled': disabled}" (click)="show($event)" [title]="selectedOption?.label || ''">
          <div class="svg-icon-wrapper">
            @if (selectedOption) {<svg-icon [icon]="selectedOption.icon"></svg-icon>}
          </div>
        </a>
      </div>
    </div>
  `,
    styleUrls: ['./mix-on-the-fly-component.scss'],
    providers: [MIX_ON_THE_FLY_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MixOnTheFlyComponent implements ControlValueAccessor, OnInit, OnChanges {

  @ViewChild('icon', { read: ElementRef })
  private icon: ElementRef;

  @ViewChild('op')
  private panel: Popover;

  private _options: any[] = MixOptions;

  private _disabled: boolean;

  value: any;
  selectedOption: any;
  originalOptionsList: any[] = MixOptions;
  
  onChange: any = () => { };
  onTouched: any = () => { };

  // eslint-disable-next-line
  @Output() mixIdChanged = new EventEmitter<any>();

  @Input() mixId: string;

  @Input()
  get options() { return this._options; }

  set options(options: any[]) {
    // eslint-disable-next-line
    this.filterOptions(options);
    this.updateSelectedOption(this.value);
  }

  @Input()
  get disabled() { return this._disabled; }

  set disabled(disabled: boolean) {
    this._disabled = disabled;
    if (!(this.cd as ViewRef).destroyed) {
      this.cd.detectChanges();
    }
  }

  @Input() isLiquid: boolean;

  constructor(public el: ElementRef,
    public renderer: Renderer2,
    public cd: ChangeDetectorRef) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLiquid']) {
      this.filterOptions();
    }
  }

  ngOnInit(): void {
    if (this.mixId) {
      this.onChange(this.mixId);
      this.updateSelectedOption(this.mixId);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.value = value;
    this.updateSelectedOption(value);
    this.cd.markForCheck();
  }

  selectItem(event, option: any) {
    this.selectedOption = option;
    this.value = option.value;
    this.mixIdChanged.next(this.value);

    if (Object.keys(event).length === 0) {
      return;
    }

    try {
      this.onChange(this.value);
    } catch (_e) { /* empty */ }
    setTimeout(() => {
      if (this.panel) {

        try {
          this.hide();
        } catch (_e) { /* empty */ }
      }
    }, 100);
  }

  hide() {
    this.panel.hide();
    this.onTouched();
  }

  show(event?) {
    if (!this.disabled) {
      this.panel.show(event);
    }
  }

  private updateSelectedOption(value: any) {
    if (this._options) {
      this.selectedOption = this._options.find((opts) => opts.value === value);

      if (this.mixId) {
        this.selectedOption = this._options.find((opts) => opts.value === this.mixId);
        this.value = this.selectedOption ? this.selectedOption.value : undefined;
      }

      if (this.selectedOption == null) {
        this.selectedOption = this.originalOptionsList.find(x => x.value === value);
      }
    } else {
      this.selectedOption = null;
    }


    this.cd.markForCheck();
  }
  private filterOptions(options: any[] = undefined): void{
    if (options === undefined) options = MixOptions;
    if (options)
      this._options = this.isLiquid && options ? options.filter(x => x.label !== 'None (blank)') : options;    
  }
}
